var map = {
	"./fakturaonline-logo-cs.svg": 1126,
	"./fakturaonline-logo-de.svg": 1387,
	"./fakturaonline-logo-en.svg": 1388,
	"./fakturaonline-logo-es.svg": 1389,
	"./fakturaonline-logo-gb.svg": 1390,
	"./fakturaonline-logo-nl.svg": 1391,
	"./fakturaonline-logo-pl.svg": 1392,
	"./fakturaonline-logo-rs.svg": 1393,
	"./fakturaonline-logo-sk.svg": 1394
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1761;